exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mavonEditor[data-v-02fed58b]{width:100%;height:100%}", ""]);

// exports
